;(() => {
    document.querySelectorAll('.js-upload-file').forEach(upload => {
        let input = upload.querySelector('.js-upload-file__input')
        const output = upload.querySelector('.js-upload-file__output')
        
        const bUploadInputInOutput = upload.dataset.uploadInputInOutput
        const bBlackAttachment = upload.dataset.blackAttachment
        const keepStructureOnUpdate = upload.dataset.keepStructureOnUpdate == 'true'

        let deleteButtons = null

        if (!bUploadInputInOutput) {
            output.innerHTML = ''
        }

        inputSubscribe()

        const inputControlNode = upload.querySelector('.input-file')
        const inputControlParentNode = inputControlNode.parentNode
        
        function inputSubscribe() {
            input.addEventListener('change', changeHandler)
        }

        function changeHandler(e) {
            const files = e.target.files
            updateOutput(files)
        }

        function updateOutput(files) {
            output.innerHTML = ''
            
            for (let i = 0; i < files.length; ++i) {
                
                const name = CNS.shortenStr(files[i].name, 15)
                // const attachment = `
                // <div class="attachment ${bBlackAttachment ? 'attachment_black' : ''}">
                //     <div class="icon ${bBlackAttachment ? 'icon_white' : ''} icon_s14 icon_attachment attachment__prefix-icon"></div>
                //     <span class="attachment__name">${name}</span>
                //     <div class="icon icon_s13 icon_gray icon_delete attachment__suffix-icon cursor-pointer js-remove"></div>
                // </div>
                // `

                const attachment = `
                        <div class="attachment-v2">
                        <div class="attachment-v2__preview">
                            <img src="/user-v2/img/graphics/attachtment-preview.jpg" alt="preview">
                        </div>
                        <span class="attachment-v2__name">${name}</span>
                        <button class="js-remove attachment-v2__remove"></button>
                    </div>
                `
                output.innerHTML += attachment
            }

            if (!keepStructureOnUpdate) {
                inputControlParentNode.appendChild(inputControlNode)
            }

            deleteButtons = Array.from(output.querySelectorAll('.js-remove'))
            
            deleteButtons.forEach(deleteButton => {
                deleteButton.addEventListener('click', () => {
                    const index = deleteButtons.indexOf(deleteButton)
                    CNS.removeFileFromFileList(index, input)
                    updateOutput(input.files)
                })
            })
        }
    })
})();